import React from 'react';
import { useSelector } from 'react-redux';
import { AdminOrganizationsSelectors } from 'store/selectors';
import { RootState } from 'store/rootReducer';
import TabTitle, { TabTitleProps } from './TabTitle';

type AdminOrganizationTabTitleProps = TabTitleProps & {
  i18nDefaultKey?: string;
  organizationId: number;
};

const AdminOrganizationTabTitle: React.FC<React.PropsWithChildren<AdminOrganizationTabTitleProps>> = ({
  organizationId,
  i18nKey,
  i18nDefaultKey,
  ...rest
}) => {
  const organizations = useSelector((state: RootState) =>
    AdminOrganizationsSelectors.adminAllOrganizationsEntities(state),
  );
  const organization = organizations && organizations.find((organization) => organization.id === organizationId);

  const directTitle = !i18nKey && organization?.title;

  return (
    <TabTitle
      directTitle={directTitle}
      i18nKey={organization?.title ? i18nKey : i18nDefaultKey}
      organization={organization?.title}
      {...rest}
    />
  );
};

export default AdminOrganizationTabTitle;
